<script>
import Modal from "@/components/_Shared/Modal";
import vDialog from "@/components/_Shared/Dialog";
import WhyDialog from "@/components/Freshdesk/Cancellation/Why";
import SuccessDialog from "@/components/Freshdesk/Success/Success";
import moment from "moment";

import freshdeskMixin from "@/mixins/freshdeskMixin";
import { mapActions } from "vuex";

export default {
  mixins: [freshdeskMixin],
  props: {
    order: Object,
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal,
    vDialog,
    WhyDialog,
    SuccessDialog
  },
  methods: {
    ...mapActions("freshdesk", ["createCreditHoursTicket"]),
    closeOptionsDialog() {
      this.$emit("close");
    },
    openWhyDialog() {
      this.whyVisibility = true;
    },
    closeWhyDialog() {
      this.whyVisibility = false;
    },
    closeSuccessDialog() {
      this.successDialogVisibility = false;
    },
    setTicketTags(order) {
      this.setCustomerTypeTag(order);
      this.setAdvanceTimeTag(order);
    },
    async submit() {
      if (this.disableSendTicketButton) return;
      this.disableSendTicketButton = true;
      this.loader = true;
      this.setTicketTags(this.order);
      try {
        let payload = {
          order: this.order,
          tags: this.ticketTags
        };
        await this.createCreditHoursTicket(payload);
        this.successDialogVisibility = true;
        this.loader = false;
      } catch (e) {
        this.disableSendTicketButton = false;
        this.loader = false;
        this.$toasted.error(e);
      }
    }
  },
  data() {
    return {
      whyVisibility: false,
      successDialogVisibility: false,
      loader: false,
      disableSendTicketButton: false
    };
  }
};
</script>
<template>
  <div>
    <modal
      title="SOLICITAR CANCELAMENTO"
      size="md"
    >
      <template slot="body">
        <form @submit.prevent="submit">
          <h3>Você sabia que pode deixar suas horas como crédito e utilizar em outra data?</h3>
          <base-flex direction="column" class="mt-30">
            <div class="btn bg-purple" type="submit" 
              :class="{'btn--loading': loader}" 
              :disabled="disableSendTicketButton"
              @click="submit()">Sim, quero deixar como horas de crédito</div>
            <div class="btn bg-purple" type="submit" @click="openWhyDialog()">Quero solicitar o cancelamento</div>
            <div class="btn bg-purple-outline" @click="$emit('close')">não quero cancelar</div>
          </base-flex>
        </form>
      </template>
    </modal>
    <why-dialog
      :order="order"
      v-if="whyVisibility"
      @close="closeWhyDialog(); closeOptionsDialog()"
      />
    <success-dialog 
      :visible="successDialogVisibility"
      @close="closeSuccessDialog(); closeOptionsDialog()"
    />
  </div>
</template>

<style lang="scss" scoped>
.btn {
  text-transform: uppercase;
  font-weight: 500;
}
.dates {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
  div {
    padding: 8px 15px;
    border-radius: 30px;
    background-color: rgba($purple, 0.1);
    color: $purple;
    margin: 5px;
    &:first-child {
      opacity: 0.6;
    }
  }
}
.keep-professional-text {
  margin-top: 10px;
  font-size: 14px;
  color: $purple;
  @media (min-width: 768px) {
    text-align: left;
    padding-left: 5px;
    border-left: 1px solid $purple;
  }
}
form {
  display: flex;
  flex-direction: column;
  align-items: center;
}
h3 {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 10px;
  color: $purple;
  text-align: center;
}
.radio-group {
  label {
    opacity: 0.6;
    margin: 10px 0;
    border-radius: 100px;
    background-color: rgba($purple, 0.04);
    padding: 15px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: $purple;
    text-align: center;
    cursor: pointer;
    small {
      font-weight: 400;
    }
    &::before {
      content: "";
      display: inline-block;
      min-width: 10px;
      min-height: 10px;
      border-radius: 100%;
      border: 2px solid $purple;
      margin-bottom: 5px;
    }
  }
  input {
    display: none;
    &:checked ~ label {
      opacity: 1;
      &::before {
        background-color: $purple;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Freshdesk/Cancellation/Cancel.vue